const SECTION_SELECTOR = '.jlf-home-services';
const TRACK_SELECTOR = '.section-content-wrapper';
const CARD_SELECTOR = ':scope > .group-block';

function getCards(track) {
  return Array.from(track.querySelectorAll(CARD_SELECTOR));
}

function getCardScrollLeft(cards, index) {
  const firstCard = cards[0];
  const card = cards[index];

  if (!firstCard || !card) return 0;

  return card.offsetLeft - firstCard.offsetLeft;
}

function setActiveDot(track, cards, dots) {
  let activeIndex = 0;
  let closestDistance = Infinity;

  cards.forEach((card, index) => {
    const distance = Math.abs(track.scrollLeft - getCardScrollLeft(cards, index));

    if (distance < closestDistance) {
      closestDistance = distance;
      activeIndex = index;
    }
  });

  dots.forEach((dot, index) => {
    const isActive = index === activeIndex;
    dot.toggleAttribute('aria-current', isActive);
  });
}

function initServicesSlider(section) {
  if (section.dataset.jlfHomeServicesSlider === 'true') return;

  const sectionInner = section.querySelector(':scope > .section');
  const track = section.querySelector(TRACK_SELECTOR);

  if (!sectionInner || !track) return;

  const cards = getCards(track);

  if (cards.length < 2) return;

  section.dataset.jlfHomeServicesSlider = 'true';
  section.querySelector('.jlf-home-services__dots')?.remove();

  const dotsWrapper = document.createElement('div');
  dotsWrapper.className = 'jlf-home-services__dots';
  dotsWrapper.setAttribute('aria-label', 'Slider servizi');

  const dots = cards.map((card, index) => {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'jlf-home-services__dot';
    dot.setAttribute('aria-label', `Vai alla scheda ${index + 1}`);
    dot.addEventListener('click', () => {
      track.scrollTo({
        left: getCardScrollLeft(cards, index),
        behavior: 'smooth',
      });
    });
    dotsWrapper.appendChild(dot);
    return dot;
  });

  sectionInner.appendChild(dotsWrapper);

  let animationFrame = 0;
  const requestUpdate = () => {
    cancelAnimationFrame(animationFrame);
    animationFrame = requestAnimationFrame(() => setActiveDot(track, cards, dots));
  };

  track.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener(
    'resize',
    () => {
      track.scrollLeft = getCardScrollLeft(cards, 0);
      requestUpdate();
    },
    { passive: true }
  );
  track.scrollLeft = getCardScrollLeft(cards, 0);
  requestUpdate();
}

function initAllServicesSliders(root = document) {
  root.querySelectorAll(SECTION_SELECTOR).forEach(initServicesSlider);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAllServicesSliders(), { once: true });
} else {
  initAllServicesSliders();
}

document.addEventListener('shopify:section:load', (event) => initAllServicesSliders(event.target));
